__turbopack_context__.v({
  "error": "table-module-scss-module__Ut4hRG__error",
  "header": "table-module-scss-module__Ut4hRG__header",
  "item": "table-module-scss-module__Ut4hRG__item",
  "link": "table-module-scss-module__Ut4hRG__link",
  "list": "table-module-scss-module__Ut4hRG__list",
  "name": "table-module-scss-module__Ut4hRG__name",
  "warning": "table-module-scss-module__Ut4hRG__warning",
});
